import React, { CSSProperties, PropsWithChildren } from "react";
import styled, { useTheme } from "styled-components";
import { AnimatePresence, motion } from "motion/react";
import { getFadeInOutVariant } from "common/Animations/variants";
import {
  OverlayProps as SharedOverlayProps,
  overlayStyles,
} from "@shared/common/Overlays/Overlay";

export interface OverlayProps extends SharedOverlayProps {
  wrapStyle?: CSSProperties;
  className?: string;
}

const Overlay: React.FunctionComponent<PropsWithChildren<OverlayProps>> = ({
  isLoading,
  children,
  spinnerMarginTop,
  overlayOpacity,
  hideContentWhileLoading,
  backgroundColor,
  wrap,
  wrapStyle,
  zIndex,
  className,
  animate,
  overlayContent,
}) => {
  const appTheme = useTheme();

  const showContent = !hideContentWhileLoading || !isLoading;
  const spinnerWrapperProps = {
    $spinnerMarginTop: spinnerMarginTop,
    $overlayOpacity: overlayOpacity,
    $backgroundColor: backgroundColor,
    $zIndex: zIndex,
    className: className,
  };

  let opacity = appTheme.isDarkMode ? 0.9 : 0.7;
  if (overlayOpacity) {
    opacity = appTheme.isDarkMode ? overlayOpacity : overlayOpacity - 0.1;
  }

  const contentWithLoading = (
    <>
      {/*@ts-ignore*/}
      <AnimatePresence>
        {isLoading && (
          <OverlayWrapper
            {...spinnerWrapperProps}
            variants={getFadeInOutVariant(opacity)}
            initial={animate ? "enter" : "center"}
            animate="center"
            exit={animate ? "exit" : "center"}
            transition={{ duration: 0.2 }}
          >
            {overlayContent}
          </OverlayWrapper>
        )}
      </AnimatePresence>
      {hideContentWhileLoading ? (
        <ContentWrapper $hide={!showContent} style={wrapStyle}>
          {children}
        </ContentWrapper>
      ) : (
        children
      )}
    </>
  );

  return wrap ? (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        ...(wrapStyle || {}),
      }}
    >
      {contentWithLoading}
    </div>
  ) : (
    contentWithLoading
  );
};

export default Overlay;

export const OverlayWrapper = styled(motion.div)<{
  $backgroundColor?: string;
  $zIndex?: number;
  $spinnerMarginTop?: number;
  $overlayOpacity?: number;
  $rounded?: boolean;
}>`
  ${overlayStyles};
`;
const ContentWrapper = styled.div<{ $hide: boolean }>`
  ${(p) =>
    p.$hide &&
    `
    opacity: 0;
  `}
`;
